export const expandMeetingEdit ={
    period: "",
    createdBy: "",
    organizationId: "",
    meetingSchedule: "",
    locationId: "",
    meetingName: "",
    meetingdate: "",
    venue: "",
    participants: [],
    minutesofMeeting: "",
    attachments: [],
    agenda: [],
}